var _excluded = ["analyticsAttributes", "className", "colorCount", "footerContent", "href", "imageProps", "imageRef", "hoverImageProps", "name", "pillProps", "postImageContent", "priceProps", "showColorsOnHover", "swatches", "onProductClick", "totalProductTileCount"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import Image from '../image';
import LinkGenerator from '../link-generator';
import Price, { priceType } from '../price';
import { convertAsterisk } from '../../utils/helpers';
import Pill from '../pill';
require("./product-tile.css");
var styles = {
  "productTile": "productTile-2306I",
  "productTileLink": "productTileLink-2IV_n",
  "image": "image-25hre",
  "imageLoadingContainer": "imageLoadingContainer-V9y1S",
  "imageContainer": "imageContainer-xkkHv",
  "imageContainerHover": "imageContainerHover-1d_Xs",
  "imageContainerDefault": "imageContainerDefault-2qNTk",
  "imageDefault": "imageDefault-1K6da",
  "imageHover": "imageHover-3BbrV",
  "productDetails": "productDetails-1C31k",
  "productAttributes": "productAttributes-2_AFr",
  "productAttributesName": "productAttributesName-1PluY",
  "pillContainer": "pillContainer-3MD5K",
  "colorsContainer": "colorsContainer-1M-U7",
  "showColorsOnHover": "showColorsOnHover-2BIYD",
  "colorCount": "colorCount-1F1XC"
};
export var DEFAULT_IMAGE_MAX_WIDTH = 1440;
var ProductTile = _ref => {
  var _priceProps$salePrice;
  var {
      analyticsAttributes,
      className,
      colorCount,
      footerContent,
      href,
      imageProps,
      imageRef,
      hoverImageProps,
      name,
      pillProps,
      postImageContent,
      priceProps,
      showColorsOnHover,
      swatches,
      onProductClick,
      totalProductTileCount
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var [isImageLoaded, setIsImageLoaded] = useState(false);
  var isSaleProduct = (priceProps === null || priceProps === void 0 ? void 0 : priceProps.salePrices) && (priceProps === null || priceProps === void 0 ? void 0 : (_priceProps$salePrice = priceProps.salePrices) === null || _priceProps$salePrice === void 0 ? void 0 : _priceProps$salePrice.length) !== 0;
  var clonedPriceProps = _objectSpread({}, priceProps);
  if (isSaleProduct) {
    var _priceProps$classes;
    clonedPriceProps.classes = _objectSpread(_objectSpread({}, priceProps === null || priceProps === void 0 ? void 0 : priceProps.classes), {}, {
      prices: cs(priceProps === null || priceProps === void 0 ? void 0 : (_priceProps$classes = priceProps.classes) === null || _priceProps$classes === void 0 ? void 0 : _priceProps$classes.prices, 'lll-text-strikethrough')
    });
  }
  var handleProductClick = () => onProductClick && onProductClick(_objectSpread(_objectSpread(_objectSpread({}, analyticsAttributes), priceProps), {}, {
    isSale: isSaleProduct,
    totalProductTileCount: totalProductTileCount
  }));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cs(styles.productTile, className)
  }, otherProps), /*#__PURE__*/React.createElement(LinkGenerator, _extends({}, analyticsAttributes, {
    "aria-label": "View details of ".concat(convertAsterisk(name.trim(), '')),
    className: cs(styles.imageContainer, styles.productTileLink, {
      [styles.imageLoadingContainer]: !isImageLoaded
    }),
    href: href,
    onClick: handleProductClick
  }), hoverImageProps && /*#__PURE__*/React.createElement(Image, _extends({}, hoverImageProps, {
    maxWidth: hoverImageProps.maxWidth || DEFAULT_IMAGE_MAX_WIDTH,
    className: cs(styles.image, styles.imageHover, {
      [hoverImageProps.className]: hoverImageProps.className
    })
  })), /*#__PURE__*/React.createElement(Image, _extends({}, imageProps, {
    maxWidth: imageProps.maxWidth || DEFAULT_IMAGE_MAX_WIDTH,
    className: cs(styles.image, {
      [styles.imageDefault]: hoverImageProps,
      [imageProps.className]: imageProps.className
    }),
    ref: imageRef,
    onLoad: () => {
      setIsImageLoaded(true);
    }
  })), pillProps && /*#__PURE__*/React.createElement("div", {
    className: styles.pillContainer,
    "data-testid": "pill"
  }, /*#__PURE__*/React.createElement(Pill, pillProps)), postImageContent), /*#__PURE__*/React.createElement("div", {
    className: styles.productDetails
  }, swatches ? /*#__PURE__*/React.createElement("div", {
    className: cs(styles.colorsContainer, {
      [styles.showColorsOnHover]: showColorsOnHover
    }),
    "data-testid": "colors-container"
  }, /*#__PURE__*/React.cloneElement(React.Children.only(swatches), {
    name,
    pdpLinkAnalyticsAttributes: analyticsAttributes,
    href,
    onSwatchClick: data => onProductClick && onProductClick(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, data), analyticsAttributes), priceProps), {}, {
      isSale: isSaleProduct,
      totalProductTileCount: totalProductTileCount
    }))
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: styles.productAttributes
  }, /*#__PURE__*/React.createElement("h3", {
    className: "lll-text-body-1 lll-font-weight-medium"
  }, /*#__PURE__*/React.createElement(LinkGenerator, _extends({}, analyticsAttributes, {
    className: cs(styles.productAttributesName, styles.productTileLink),
    href: href,
    onClick: handleProductClick
  }), convertAsterisk(name.trim(), '\n'))), priceProps && /*#__PURE__*/React.createElement("span", {
    className: "lll-text-body-1"
  }, /*#__PURE__*/React.createElement(Price, clonedPriceProps)), colorCount && /*#__PURE__*/React.createElement("span", {
    className: cs(styles.colorCount, 'lll-text-body-3')
  }, colorCount, " colours")), footerContent));
};
ProductTile.propTypes = {
  /** Defines HTML attributes for link tracking (e.g., { "data-lulu-track": "pdp-link" }) */
  analyticsAttributes: PropTypes.shape({}),
  className: PropTypes.string,
  /** The number of colors available for the product.
  /** If using swatches, this should usually match the swatches length */
  colorCount: PropTypes.number,
  /** Content inserted at the bottom of the product tile for non-standard use cases */
  footerContent: PropTypes.node,
  href: PropTypes.string.isRequired,
  /** Accepts same props list as <Image /> component */
  imageProps: PropTypes.shape(_objectSpread({
    className: PropTypes.string,
    maxWidth: PropTypes.number
  }, Image.propTypes)).isRequired,
  /** A ref to be added to the main product image */
  imageRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /** Passes secondary image data that includes an image to be displayed onHover */
  hoverImageProps: PropTypes.shape(_objectSpread({
    className: PropTypes.string,
    maxWidth: PropTypes.number
  }, Image.propTypes)),
  name: PropTypes.string.isRequired,
  /** Accepts same props list as <Pill /> component */
  pillProps: PropTypes.shape(_objectSpread({}, Pill.propTypes)),
  /** Content inserted after the product image for non-standard use cases */
  postImageContent: PropTypes.node,
  /** Accepts same props list as <Price /> component */
  priceProps: PropTypes.shape(_objectSpread({
    classes: PropTypes.shape({
      prices: PropTypes.string
    }),
    salePrices: priceType
  }, Price.propTypes)),
  /** Allows color swatches to be displayed onHover */
  showColorsOnHover: PropTypes.bool,
  /** A ProductTileSwatches component */
  swatches: PropTypes.node,
  onProductClick: PropTypes.func,
  /**total productTiles count for analytics*/
  totalProductTileCount: PropTypes.number
};
ProductTile.defaultProps = {
  analyticsAttributes: {},
  className: '',
  colorCount: null,
  footerContent: null,
  hoverImageProps: null,
  imageRef: undefined,
  pillProps: null,
  postImageContent: null,
  showColorsOnHover: false,
  swatches: null,
  priceProps: null,
  onProductClick: () => {},
  totalProductTileCount: 0
};
export default ProductTile;